import { ApiOutlined, ReloadOutlined, ShopOutlined } from '@ant-design/icons';

import { Button, Empty } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { maLoi } from '../../../../lib/errors';
import { useMoTaLoi } from '../hooks/useMoTaLoi';

/**
 * Trạng thái LỖI của một vùng dữ liệu Nhật ký & Truy vết — thay chỗ native viết lặp `<p>{moTaLoi(err)}</p>` + Thử lại
 * ở mỗi màn. Hai lỗi nói riêng vì bấm Thử lại ở đó không bao giờ khác đi (cùng cách `tro-ly-ai/VungDuLieu`):
 * - `TENANT_DOMAIN_NOT_VERIFIED`: nhân sự nền tảng xem chéo giao diện tenant (ADR-UI-0012 mục 9);
 * - `API_UNAVAILABLE`: audit-service chưa phục vụ module trên máy chủ này (Gateway trả 404/502 của chính nó).
 *
 * `gon`: một dòng chữ + nút nhỏ, cho chỗ hẹp (tab Lịch sử nhúng, chuỗi xử lý trong ngăn kéo).
 */
export function KhoiLoi({ loi, onThuLai, gon = false }: { loi: unknown; onThuLai?: () => void; gon?: boolean }) {
  const { t } = useT();
  const moTaLoi = useMoTaLoi();
  const ma = maLoi(loi);
  const nutThuLai = onThuLai ? (
    <Button variant="outline" size="sm" icon={<ReloadOutlined />} onClick={onThuLai}>
      {t('nktv.trangThai.thuLai')}
    </Button>
  ) : undefined;

  if (ma === 'TENANT_DOMAIN_NOT_VERIFIED') {
    return <Empty icon={ShopOutlined} title={t('nktv.loi.xemCheoTieuDe')} description={t('nktv.loi.xemCheoMo')} />;
  }
  if (ma === 'API_UNAVAILABLE') {
    return (
      <Empty
        icon={ApiOutlined}
        title={t('nktv.loi.chuaSanSangTieuDe')}
        description={t('nktv.loi.chuaSanSangMo')}
        action={nutThuLai}
      />
    );
  }
  if (gon) {
    return (
      <div className="space-y-2 py-2" role="alert">
        <p className="break-words text-sm text-danger-700">{moTaLoi(loi)}</p>
        {nutThuLai}
      </div>
    );
  }
  return (
    <div className="p-4" role="alert">
      <div className="rounded-lg border border-danger-100 bg-danger-50 p-4 text-sm text-danger-700">
        <p className="break-words">{moTaLoi(loi)}</p>
        {nutThuLai && <div className="mt-3">{nutThuLai}</div>}
      </div>
    </div>
  );
}
